import React from 'react';
import { Box, Flex, Heading, ScaleFade, Text } from '@chakra-ui/react';

import { HeaderUp } from '../../../components/_components_0.2/Header_0.2';
import { Sidebar } from '../../../components/_components_0.2/Sidebar_0.2';
import { MobileNav } from './MobileNav';

interface PageShellProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
}

/**
 * Esqueleto das telas do Controle de Análises de Ração (HeaderUp + Sidebar),
 * o mesmo do Controle de Qualidade, com título e ações no topo.
 */
export const PageShell: React.FC<PageShellProps> = ({
  title,
  subtitle,
  actions,
  children,
}) => (
  <ScaleFade initialScale={0.95} in>
    <Flex direction="column" minH="100vh">
      <HeaderUp path="feed-analysis" />
      <Flex
        w="100%"
        my={{ base: '4', md: '6' }}
        maxWidth={1480}
        mx="auto"
        pb={8}
        px={{ base: '4', md: '6' }}
      >
        <Sidebar path="feed-analysis" />
        <Box flex="1" minW="0">
          <MobileNav />
          <Flex
            justify="space-between"
            align={{ base: 'stretch', md: 'flex-end' }}
            direction={{ base: 'column', md: 'row' }}
            gridGap="3"
            mb="6"
          >
            <Box>
              <Heading size="lg" fontWeight="600">
                {title}
              </Heading>
              {subtitle && (
                <Text color="gray.400" fontSize="sm" mt="1">
                  {subtitle}
                </Text>
              )}
            </Box>
            {actions && (
              <Flex gridGap="2" flexWrap="wrap">
                {actions}
              </Flex>
            )}
          </Flex>
          {children}
        </Box>
      </Flex>
    </Flex>
  </ScaleFade>
);
